import { Button, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import CustomTextField from '../formFields/textField';
import { ICONS } from 'src/assets/library';

const Notes = () => {
  return (
    <Container sx={{ minWidth: '320px', width: '420px' }}>
      <Typography variant="h4">Notes</Typography>
      <Grid container xs={12} sx={{ minHeight: '300px', overFlowY: 'auto' }}>
        No notes right now
      </Grid>
      <Grid container xs={12} spacing={1}>
        <Grid item xs={10}>
          <CustomTextField placeholder={'Add note'} />
        </Grid>
        <Grid item xs={2}>
          <Button variant="contained">{ICONS.send}</Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Notes;
